import { Link, NavLink, Outlet } from 'react-router-dom';
import Toast from '../../components/admin/ui/Toast';
import '../../css/admin/layout.css';

const ICONS = {
  projets: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 6h14M3 10h14M3 14h9" />
    </svg>
  ),
  experiences: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M4 16V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10l-6-3-6 3Z" />
    </svg>
  ),
  formations: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M10 3 3 7l7 4 7-4-7-4Z" />
      <path d="M3 13l7 4 7-4" />
    </svg>
  ),
  technologies: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="10" cy="10" r="2.3" />
      <path d="M10 3v2M10 15v2M3 10h2M15 10h2M5 5l1.4 1.4M13.6 13.6 15 15M15 5l-1.4 1.4M6.4 13.6 5 15" />
    </svg>
  ),
  textes: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M4 4h12v12H4z" />
      <path d="M4 8h12M8 8v8" />
    </svg>
  ),
  bibliotheque: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="4" width="14" height="12" rx="1.5" />
      <circle cx="7" cy="8.5" r="1.3" />
      <path d="M3 14l4.5-4 3 2.5L15 8l2 2.5" />
    </svg>
  ),
  analytics: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M4 16V4M4 16h12" />
      <path d="M7 13v-4M10.5 13V6M14 13v-6" />
    </svg>
  ),
  logout: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M8 4H4v12h4M13 10H4M10 6l4 4-4 4" />
    </svg>
  )
};

const NAV_GROUPS = [
  {
    label: 'Contenu',
    items: [
      { to: '/admin-bj/projets', label: 'Projets', icon: 'projets' },
      { to: '/admin-bj/experiences', label: 'Expériences', icon: 'experiences' },
      { to: '/admin-bj/formations', label: 'Formations', icon: 'formations' },
      { to: '/admin-bj/technologies', label: 'Technologies', icon: 'technologies' }
    ]
  },
  {
    label: 'Site',
    items: [
      { to: '/admin-bj/textes', label: 'Textes des pages', icon: 'textes' },
      { to: '/admin-bj/bibliotheque', label: 'Bibliothèque', icon: 'bibliotheque' },
      { to: '/admin-bj/analytics', label: 'Analytics', icon: 'analytics' }
    ]
  }
];

function AdminLayout({ onLogout, toast }) {
  return (
    <div className="admin">
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <Link to="/admin-bj" className="admin-sidebar-mark" aria-label="Retour au tableau de bord">
            <img src="/logo_BJ/Logo_BJ_v2%20noir.png" alt="Logo" />
          </Link>

          {NAV_GROUPS.map((group) => (
            <div key={group.label}>
              <div className="admin-nav-label">{group.label}</div>
              <nav>
                {group.items.map((item) => (
                  <NavLink key={item.to} to={item.to} className={({ isActive }) => (isActive ? 'active' : '')}>
                    <span className="admin-nav-icon">{ICONS[item.icon]}</span>
                    {item.label}
                  </NavLink>
                ))}
              </nav>
            </div>
          ))}

          <div className="admin-sidebar-bottom">
            <button type="button" className="admin-logout-btn" onClick={onLogout}>
              <span className="admin-nav-icon">{ICONS.logout}</span>
              Se déconnecter
            </button>
          </div>
        </aside>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
      <Toast message={toast} />
    </div>
  );
}

export default AdminLayout;
